<script setup lang="ts">
import Token from '../global/Token.vue';

import StartLogo from '@/ui/StartLogo.vue';
import { useAgentLoggedQuery } from '@/graphql/generated/graphql';
import Redirect from '~/global/Redirect.vue';

const { data, fetching } = useAgentLoggedQuery({});
</script>
<template>
  <Token>
    <StartLogo v-if="fetching" text="Loading agent..." :percent="90" />
    <Redirect v-else-if="!!data?.agentLogged" name="schools" message="Redirecting to your session..." />
    <slot v-else />
  </Token>
</template>
